<nav class="page-header-top-half" aria-label="Breadcrumb">
  <ol role="list" class="page-header-top-half-breadcrumb-list">
    <!-- <sidkik-breadcrumb-home *ngIf="includeHome" [trailItem]="home"></sidkik-breadcrumb-home> -->
    <sidkik-breadcrumb-item *ngFor="let trailItem of trail.items; index as i" [trailItem]="trailItem"
      [isFirst]="!includeHome && i === 0" [index]="i"></sidkik-breadcrumb-item>
  </ol>
</nav>